import { Box, TextField, Typography } from "@mui/material";
import Add from "@mui/icons-material/Add";
import { useState } from "react";

export function CalendarAddTask(props: {
    // a month cell only offers the add row while the pointer is over it
    visible: boolean;
    onCreate: (title: string) => void;
}) {
    const [typing, setTyping] = useState(false);
    const [title, setTitle] = useState("");

    // the field stays open after a title is sent, so several tasks can be typed in a
    // row with enter between them; escape or clicking away closes it
    const submit = () => {
        const value = title.trim();
        if (!value) return;

        setTitle("");
        props.onCreate(value);
    };

    if (!typing && !props.visible) return null;

    if (!typing) {
        return (
            <Box
                onClick={e => {
                    e.stopPropagation();
                    setTyping(true);
                }}
                sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 0.25,
                    flexShrink: 0,
                    px: 0.5,
                    borderRadius: 0.75,
                    color: "text.disabled",
                    cursor: "pointer",
                    // a translucent tint so the row reads the same on a white, a
                    // weekend and an out-of-month cell
                    "&:hover": { bgcolor: "action.hover", color: "text.secondary" },
                }}
            >
                <Add sx={{ fontSize: 14 }} />
                <Typography variant="caption">Add task</Typography>
            </Box>
        );
    }

    return (
        <TextField
            variant="standard"
            autoFocus
            fullWidth
            placeholder="Task name"
            value={title}
            onClick={e => e.stopPropagation()}
            onChange={e => setTitle(e.target.value)}
            // keep whatever was typed until it's sent or explicitly dropped
            onBlur={() => { if (!title.trim()) setTyping(false); }}
            onKeyDown={e => {
                e.stopPropagation();

                if (e.key === "Enter") {
                    e.preventDefault();
                    submit();
                }

                if (e.key === "Escape") {
                    setTitle("");
                    setTyping(false);
                }
            }}
            sx={{ flexShrink: 0, px: 0.5 }}
            slotProps={{ input: { sx: { fontSize: 12 } } }}
        />
    );
}
